<template>
  <div class="app">
    <app-header fixed :style="bannerStyle">
      <b-navbar variant="faded" type="light" class="d-sm-down-none">
        <b-navbar-brand href="#" :key="drawLogo">
          <img v-if="companyLogo" height="50" :src="companyLogo" alt="ERP ekossystem" />
          <img v-else height="50" src="assets/img/logo_erp.svg" alt="ERP ekossystem" />
        </b-navbar-brand>
      </b-navbar>
      <b-navbar-nav>
        <b-nav-item href="#" class="ml-3" @click="modulClick">
          <span :class="textClass"><i class="fa fa-th-large"></i> Modules</span>
        </b-nav-item>
        <!-- <b-dropdown variant="link" :class="textClass" :text="modulName">
          <div class="shortcut-link p-3 mt-2 mb-2">
            <b-shortcut :menus="navItems"></b-shortcut>
          </div>
        </b-dropdown> -->
        <template>
          <b-dropdown variant="link" class="custom-dropdown" v-b-tooltip.hover title="click Show Menu">
            <!-- Gunakan scoped slot untuk mengatur class text -->
            <template #button-content>
              <span :class="textClass" class="d-flex align-items-center">
                {{ modulName }}
                <b-icon-chevron-down :class="textClass" class="mt-1 ml-1 custom-arrow" />
              </span>
            </template>
            <div class="shortcut-link p-3 mt-2 mb-2">
              <b-shortcut :menus="navItems"></b-shortcut>
            </div>
          </b-dropdown>
        </template>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <div class="d-sm-down-none pl-2 title font-weight-bold">
          <b-link :class="['custom-link', linkClass]" @click="selectCompany">{{ user.company || "please select company" }}</b-link>
        </div>
        <b-nav-item class="d-md-down-none" v-if="cart.display" @click="commitCart()">
          <i class="fa fa-shopping-cart"></i>
          <b-badge pill variant="warning">{{ cart.items.length }}</b-badge>
        </b-nav-item>
        <b-tasknotif />
        <b-account @logout="logout" @profile="profile" @myapp="myapp" />
      </b-navbar-nav>
    </app-header>
    <div class="app-body">
      <main class="main">
        <div class="container-fluid">
          <div class="mb-4"></div>
          <router-view></router-view>
        </div>
      </main>
    </div>
    <b-modal v-model="lkuCompanyShow" size="lg" header-bg-variant="danger" :hide-footer="true" title="Switch Company" :centered="true">
      <lku-company @click="onSelectLkuCompany"></lku-company>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.app-header {
  .app-logo {
    height: 52px;
  }

  .header-dropdown {
    margin-right: 20px;
  }
}

.shortcut-link {
  width: 900px;
  max-width: 900px;
}

.popover {
  width: 90%;
  max-width: 90%;
}
.custom-dropdown ::v-deep .dropdown-toggle::after {
  display: none !important;
}

.custom-dropdown ::v-deep .btn-link {
  padding-right: 0.5rem !important;
}

.custom-arrow {
  font-size: 0.875rem;
  margin-left: 0.25rem;
}
.custom-bg {
  transition: background-color 0.3s ease;
}
.custom-link {
  text-decoration: none;
  font-weight: bold;
  padding: 8px 16px;
  border-radius: 4px;
  display: inline-block;
}

.custom-link:hover {
  opacity: 0.8;
  transform: translateY(-1px);
}
</style>

<script>
import tinycolor from "tinycolor2";
import toastr from "mini-toastr";
import { Header as AppHeader } from "@coreui/vue";
import bAccount from "../components/account";
import bTasknotif from "../components/tasknotify";
import bShortcut from "../components/shortcut-menus-small";
import auth from "../apis/auth.js";
import dim from "../apis/dimensionsample";
import lkuCompany from "../views/lookup/lkuCompanyuser";
import { BIconChevronDown } from "bootstrap-vue";
toastr.init();

export default {
  components: {
    AppHeader,
    bAccount,
    BIconChevronDown,
    bTasknotif,
    bShortcut,
    lkuCompany,
  },
  data() {
    return {
      user: {},
      bannerStyle: {},
      navItems: [],
      lkuCompanyShow: false,
      companyLogo: "",
      drawLogo: 1,
      bgColor: "#ffffff",
    };
  },
  computed: {
    name() {
      // return this.$route.name;
      let routeRecords = this.$route.matched.filter((route) => route.name || route.meta.label);
      this.$store.commit("modul", routeRecords[0].name);
      return routeRecords[0].name;
    },
    modulName() {
      // return this.$route.name;
      let routeRecords = this.$route.matched.filter((route) => route.name || route.meta.label);
      return routeRecords[0].meta.label || "Menu";
    },
    cart() {
      const { cart } = this.$store.state;
      return cart || { items: [], cartOwner: "app.requisitionfrm" };
    },
    compcode() {
      return this.$store.state.user.compcode;
    },
    linkClass() {
      const color = tinycolor(this.bgColor);
      return color.isLight() ? "text-primary" : "text-light";
    },
    textClass() {
      const color = tinycolor(this.bgColor);
      return color.isLight() ? "text-primary" : "text-white";
    },
  },
  watch: {
    compcode: async function (newval) {
      if (this.user.compcode != newval) {
        this.user = this.$store.state.user;
        // this.$forceUpdate();
        this.refreshCompany(this.user);
      }
    },
  },
  sockets: {
    switchcompany: function (baru) {
      if (this.user.user_id === baru.user_id && this.user.compcode != baru.compcode) {
        for (var key in baru) {
          this.user[key] = baru[key];
        }
        this.refreshCompany(baru);
      }
    },
    task_changed: function (data) {
      if (data.compcode === this.$store.state.user.compcode) {
        this.$socket.emit("notificationupdate", {
          key: "notifycount",
          user: this.$store.state.user,
        });
      }
    },
  },
  created: async function () {
    this.companyLogo = localStorage.getItem("companyLogo") || "";
    const { $store } = this;
    if ($store.state.user) this.user = $store.state.user;
    this.user.company = this.user.company || "PT. Media Inisiatif";
    if (this.user) {
      if (this.user.compcolor) {
        // this.bannerStyle=`background-color: ${this.user.compcolor} !important;`;
        this.bannerStyle = { backgroundColor: this.user.compcolor };
        this.bgColor = this.user.compcolor;
      }
    }

    this.$socket.emit("notificationupdate", {
      key: "notifycount",
      user: this.$store.state.user,
    });

    setTimeout(() => {
      this.companyLogo = localStorage.getItem("companyLogo") || "";
      this.drawLogo += 1;
    }, 500);
    try {
      const [menus, dims] = await Promise.all([auth.menus(this.name), dim.dimsetup()]);
      // console.log(`menus ${this.name}: `, menus);
      this.navItems = menus;
      // console.log(' menu :', [this.name, menus]);
      $store.commit("menu", this.navItems);
      $store.commit("dimension", dims);
      // const menus = await auth.menus(this.name);
      // this.navItems = menus;
      // $store.commit("menu", this.navItems);
    } catch (error) {
      console.log("error : ", error);
      // sementara dimatikan dulu, seharusnya di paksa login, jika hanya tokennya invalid, bukan karena semua jenis Error
      window.localStorage.clear();
      this.$router.push({ name: "page.login" });
    }
  },
  methods: {
    commitCart() {
      // console.log('cart.items: ',this.cart.items);
      this.$router.push({ name: this.cart.cartOwner });
    },
    modulClick() {
      this.$router.push({ name: "app.modules" });
    },
    logout() {
      boogr.logout();
    },
    profile() {
      this.$router.push("/profile");
    },
    myapp() {
      location.href = process.env.VUE_APP_MYAPP;
    },
    selectCompany() {
      // console.log('selectCompany ke click di admin')
      this.lkuCompanyShow = true;
    },
    onSelectLkuCompany: async function (_selected) {
      if (this.user.compcode != _selected.compcode) {
        localStorage.removeItem("companyLogo");
        this.user.compcode = _selected.compcode;
        this.user.company = _selected.company;
        this.user.compaddr = `${_selected.compaddr1} ${_selected.compaddr2 || ""} ${_selected.compaddr3 || ""}`;
        this.user.compwebsite = _selected.compwebsite;
        this.user.compcolor = _selected.compcolor;
        this.user.cashinflowNo = _selected.cashinflowNo;
        this.user.cashinflowNm = _selected.cashinflowNm;
        this.user.use_wfservice = _selected.use_wfservice;
        this.user.use_procure = _selected.use_procure;
        this.user.holding = _selected.holding;
        this.user.matauang = _selected.matauang;
        this.user.tglaktif = _selected.tglaktif;
        this.user.tglkoran = _selected.tglkoran;
        this.user.akhirbln = _selected.akhirbln;
        this.user.awalbln = _selected.awalbln;

        const baru = {};
        for (var key in this.user) {
          baru[key] = this.user[key];
        }
        const resp = await auth.updateLastCompany(this.user);
        if (resp.success == true) {
          localStorage.setItem("companyLogo", resp.logo);
        }
        this.refreshCompany(baru);
      }
      this.lkuCompanyShow = false;
    },
    refreshCompany: async function (baru) {
      toastr.warn("Company has been changed");
      this.companyLogo = localStorage.getItem("companyLogo") || "";
      this.$store.commit("user", baru);
      this.$socket.emit("notificationupdate", {
        key: "notifycount",
        user: baru,
      });
      const dims = await dim.dimsetup();
      this.$store.commit("dimension", dims);
      this.bannerStyle = {};
      if (this.user.compcolor) {
        this.bannerStyle = { backgroundColor: this.user.compcolor };
      }
      window.location.reload();
      // if (!this.$route.name.includes(".home")) {
      //   this.$router.push("home");
      // }
    },
  },
};
</script>
